import { render, staticRenderFns } from "./RestaurantList.vue?vue&type=template&id=91b4c942&scoped=true&"
import script from "./RestaurantList.vue?vue&type=script&lang=js&"
export * from "./RestaurantList.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantList.vue?vue&type=style&index=0&id=91b4c942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b4c942",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VContainer,VPagination})
